import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = { modalId: String };

  openModal() {
    // Abrir el modal cuando Turbo carga el contenido (Bootstrap 4 con jQuery)
    const modalId = this.modalIdValue || this.element.id;
    const modal = document.getElementById(modalId);
    if (modal && typeof $ !== 'undefined' && $.fn.modal) {
      // Remover aria-hidden antes de mostrar el modal para evitar warnings de accesibilidad
      modal.removeAttribute('aria-hidden');
      $(modal).modal('show');
    }
  }
}
